import React, { useState } from 'react';
import {
  useNavigate
} from "react-router-dom";
import { AppBar, Toolbar, IconButton, Typography, Slide, useScrollTrigger, Box, Select, MenuItem, Tooltip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Img from '../../assets/Logo.png';
import SideNav from './SideNav';
import i18next from 'i18next';
import GermanFlag from '../../assets/Flags/GermanFlag.png'
import PolishFlag from '../../assets/Flags/PolishFlag.png'
import TurkishFlag from '../../assets/Flags/TurkishFlag.png'
import UkranianFlag from '../../assets/Flags/UkranianFlag.png'
import DeepL from '../../assets/Translators/DeepL.png'
import GoogleTranslate from '../../assets/Translators/GoogleTranslate.png'
import { useTranslation } from 'react-i18next';

export default function Header() {

  const navigate = useNavigate();

  const [sideOpen, setSideOpen] = useState(false);
  const [translation, setTranslation] = useState(i18next.language)
  const {t} = useTranslation()

  const changeTranslation = (event) => {
    i18next.changeLanguage(event.target.value);
    setTranslation(event.target.value)
  }

  const toggleSide = (open) => (event) => {    
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
    }
      setSideOpen(open);
  }

  return (
    <Box>
      <HideOnScroll>
        <Box>
          <AppBar position="static">
            <Toolbar 
              sx={{
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <IconButton 
                onClick={toggleSide(true)} 
                edge="start" 
                color="inherit" 
                aria-label="menu"
                sx={{
                  flexShrink: 1,
                  marginLeft: 1,
                  padding: 2
                }}
              >
                <MenuIcon/>
                <Typography sx={{ml: 1}}>{t("navigationMenu")}</Typography>
              </IconButton>
              <SideNav sideOpen={sideOpen} toggleSide={toggleSide}/>
              <Box sx={{display: "flex", alignItems: "center"}}>
              <Box>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={translation}
                    label="Translation"
                    onChange={changeTranslation}
                    sx={{backgroundColor: "white", height: "fit-content"}}
                    size="small"
                  >
                    <MenuItem value={"de"}><img height="10px" src={GermanFlag} alt="German flag"/>Deutsch</MenuItem>
                    <MenuItem value={"tr"}><img height="10px" src={TurkishFlag} alt="Turkish flag"/>Türk</MenuItem>
                    <MenuItem value={"pl"}><img height="10px" src={PolishFlag} alt="Polish flag"/>Polski</MenuItem>
                    <MenuItem value={"uk"}>
                      <img height="10px" src={UkranianFlag} alt="Ukrainian flag"/>
                      Українська
                    </MenuItem>
                </Select>
                {
                    translation !== "de" &&
                    <Tooltip enterTouchDelay={0} leaveTouchDelay={5000} title="This page has been translated with the help of Google Translate and DeepL">
                      <Box sx={{mt: 1}}>
                        <img src={DeepL} alt="DeepL Logo" height={20}/>
                        <img src={GoogleTranslate} alt="Google Translate Logo" height={20}/>
                      </Box>
                    </Tooltip>
                }
              </Box>
              <Box 
                sx={{
                  backgroundColor: "white",
                  margin: 2,
                  flexShrink: 1,    
                  borderRadius:{
                    xs: "50px",
                    sm: "10px"
                  }
                }}
              >
                <IconButton onClick={() => navigate("/home")}
                  sx={{
                    display:{
                      xs: "none",
                      sm: "flex"
                    },
                    flexShrink: 1
                  }}
                >
                    <Typography color="primary" variant="h5"
                      sx={{mr: 2}}
                    >Gekonnt hanDeln</Typography>
                    <img src={Img} alt="gekonnhandeln logo"
                      style={{
                        width: "50",
                        maxWidth: "3rem",
                        height: "50",
                        objectFit: "cover",
                        flexShrink: 1
                      }}
                    />
                </IconButton>
                <IconButton onClick={() => navigate("/home")}
                    sx={{
                      display:{
                        xs: "block",
                        sm: "none"
                      },
                      flexShrink: 1
                    }}
                >
                    <img src={Img} alt="gekonnhandeln logo"
                      style={{
                        width: "100%",
                        maxWidth: "3rem",
                        height: "auto",
                        objectFit: "cover",
                      }}
                    />
                </IconButton>
              </Box>
              </Box>

            </Toolbar>
          </AppBar>
        </Box>
      </HideOnScroll>
    </Box>
  );
}

function HideOnScroll(props) {
  const { children } = props;
  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}